import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconClipboard = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 2a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-3a2 2 0 0 1 2 2h1a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a2 2 0 0 1 2-2z"
      clipRule="evenodd"
    />
    <rect width={10} height={4} x={7} y={1} stroke="currentColor" strokeWidth={2} rx={2} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 11h8M8 16h8"
    />
  </NcIcon>
);
export { NcIconClipboard };
